<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                "userList" | translate
              }}</span>
            </h3>
            <div class="card-toolbar">
              <!-- Filter btn -->
              <button
                class="btn btn-icon btn-active-light-primary cursor-pointer"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                data-kt-menu-trigger="click"
                data-kt-menu-placement="bottom-end"
              >
                <i class="fa-solid fa-filter"></i>
              </button>
              <!-- Create new user btn -->
              <a
                [routerLink]="['/user/create']"
                style="margin-left: 30px"
                class="btn btn-sm fw-bold btn-primary"
                >{{ "createUser" | translate }}</a
              >
            </div>
          </div>

          <!-- User List -->
          <div class="card-body py-3">
            <div class="table-responsive">
              <!-- Filters -->
              <div class="collapse mb-8" id="collapseExample">
                <form (submit)="filterUserList($event)">
                  <div class="row">
                    <!-- Name Surname Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="nameSurname" class="form-label">{{
                        "nameSurname" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.nameSurname"
                        type="text"
                        class="form-control"
                        id="nameSurname"
                        name="nameSurname"
                        placeholder="{{ 'filterByNameSurname' | translate }}"
                      />
                    </div>
                    <!-- Role Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="userRole" class="form-label">{{
                        "role" | translate
                      }}</label>
                      <select
                        [(ngModel)]="filterForm.role"
                        class="form-select cursor-pointer"
                        aria-label="Small select example"
                        name="userRole"
                      >
                        <option [ngValue]="null" selected disabled>
                          {{ "selectRole" | translate }}
                        </option>
                        <option *ngFor="let role of roles" [value]="role?.id">
                          {{ role?.name }}
                        </option>
                      </select>
                    </div>
                    <!-- Email Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="email" class="form-label">{{
                        "email" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.email"
                        type="email"
                        class="form-control"
                        id="email"
                        name="email"
                        placeholder="{{ 'filterByEmail' | translate }}"
                      />
                    </div>
                    <!-- Organization Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="Organization" class="form-label">{{
                        "organization" | translate
                      }}</label>
                      <select
                        [(ngModel)]="filterForm.organization"
                        class="form-select cursor-pointer"
                        aria-label="Small select example"
                        name="Organization"
                      >
                        <option [ngValue]="null" selected disabled>
                          {{ "selectOrganization" | translate }}
                        </option>
                        <option
                          *ngFor="let organization of organizationList"
                          [value]="organization?.code"
                        >
                          {{ organization?.code }}
                        </option>
                      </select>
                    </div>
                    <!-- PID Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="email" class="form-label">{{
                        "pid" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.pid"
                        type="text"
                        class="form-control"
                        id="pid"
                        name="pid"
                        placeholder="{{ 'filterByPid' | translate }}"
                      />
                    </div>
                    <!-- Status Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="userStatus" class="form-label">{{
                        "status" | translate
                      }}</label>
                      <select
                        [(ngModel)]="filterForm.status"
                        class="form-select cursor-pointer"
                        aria-label="Small select example"
                        name="userStatus"
                      >
                        <option [ngValue]="null" selected disabled>
                          {{ "selectStatus" | translate }}
                        </option>
                        <option
                          *ngFor="let status of userStatus"
                          [value]="status?.id"
                        >
                          {{ status?.title }}
                        </option>
                      </select>
                    </div>
                    <!-- Start Create Date Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="startCreatedDate" class="form-label">{{
                        "startCreatedDate" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.startCreatedDate"
                        [value]="filterForm.startCreatedDate"
                        type="date"
                        class="form-control"
                        id="startCreatedDate"
                        name="startCreatedDate"
                        [max]="maxDate"
                      />
                    </div>
                    <!-- End Create Date Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="endCreatedDate" class="form-label">{{
                        "endCreatedDate" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.endCreatedDate"
                        [value]="filterForm.endCreatedDate"
                        type="date"
                        class="form-control"
                        id="endCreatedDate"
                        name="endCreatedDate"
                        [max]="maxDate"
                      />
                    </div>
                    <!-- Start Last Login Date Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="startLastLoginDate" class="form-label">{{
                        "startLastLoginDate" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.startLastLoginDate"
                        type="date"
                        class="form-control"
                        id="startLastLoginDate"
                        name="startLastLoginDate"
                        [max]="maxDate"
                      />
                    </div>
                    <!-- End Last Login Date Filter -->
                    <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="endLastLoginDate" class="form-label">{{
                        "endLastLoginDate" | translate
                      }}</label>
                      <input
                        [(ngModel)]="filterForm.endLastLoginDate"
                        type="date"
                        class="form-control"
                        id="endLastLoginDate"
                        name="endLastLoginDate"
                        [max]="maxDate"
                      />
                    </div>
                  </div>
                  <!-- Filter Action Buttons -->
                  <div
                    class="filter-btn mt-2 d-flex align-items-center gap-4 justify-content-end"
                  >
                    <button
                      (click)="clearFilters()"
                      type="button"
                      class="btn btn-secondary btn-sm cursor-pointer"
                    >
                      {{ "clear" | translate }}
                    </button>
                    <button
                      type="submit"
                      class="btn btn-primary btn-sm cursor-pointer"
                    >
                      {{ "filter" | translate }}
                    </button>
                  </div>
                </form>
              </div>
              <!-- User Table Loading -->
              <div
                *ngIf="userListLoading; else userList"
                class="d-flex justify-content-center pb-4"
              >
                <div class="spinner-border text-danger" role="status">
                  <span class="visually-hidden">userListLoading...</span>
                </div>
              </div>
              <ng-template #userList>
                <!-- If no user available -->
                <div
                  *ngIf="users && !users.length; else userListTable"
                  class="card-body py-3 text-center fs-5"
                >
                  {{ "noUsersAvailable" | translate }}
                </div>
                <!-- User Table -->
                <ng-template #userListTable>
                  <table
                    class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3"
                  >
                    <thead>
                      <tr class="fw-bold text-muted">
                        <th class="w-25px">
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value="1"
                              data-kt-check="true"
                              data-kt-check-target=".widget-13-check"
                            />
                          </div>
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "user" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "role" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "email" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "organization" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "pid" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "created" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "lastLogin" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-120px fw-bold">
                          {{ "status" | translate }}
                        </th>
                        <th class="text-gray-600 min-w-80px fw-bold">
                          {{ "actions" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let user of users">
                        <td>
                          <div
                            class="form-check form-check-sm form-check-custom form-check-solid"
                          >
                            <input
                              class="form-check-input widget-13-check"
                              type="checkbox"
                              value="1"
                            />
                          </div>
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ user.name || "-" }} {{ user.surname || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ user?.roleName || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ user?.email || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ user?.customerCode || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{ user?.pid || "-" }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{
                            user?.createdDateTime
                              ? (user?.createdDateTime | date : "dd-MM-yyyy")
                              : "-"
                          }}
                        </td>
                        <td class="text-gray-900 text-hover-primary fs-6">
                          {{
                            user?.lastLoginDate
                              ? (user?.lastLoginDate | date : "dd-MM-yyyy")
                              : "-"
                          }}
                        </td>
                        <td>
                          <span
                            [ngClass]="getUserStatusClass(user.userStatus)"
                            >{{ user?.userStatus || "-" }}</span
                          >
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <!-- Activate User -->
                            <a
                              (click)="activateUser(user?.id || '')"
                              class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                              [title]="'activateUser' | translate"
                              ><i class="fa-regular fa-circle-check"></i
                            ></a>
                            <!-- Block User -->
                            <a
                              (click)="blockUser(user?.id || '')"
                              class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                              [title]="'blockUser' | translate"
                              ><i class="fa-solid fa-ban"></i
                            ></a>
                            <!-- Edit User -->
                            <a
                              [routerLink]="['/user/edit', user?.id]"
                              class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                              [title]="'edit' | translate"
                              ><i class="fa-regular fa-pen-to-square"></i
                            ></a>
                            <!-- Delete User -->
                            <a
                              (click)="deleteModalId = user?.id || ''"
                              data-bs-toggle="modal"
                              [attr.data-bs-target]="
                                '#exampleModal-' + deleteModalId
                              "
                              class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                              [title]="'delete' | translate"
                              ><i class="fa-regular fa-trash-can"></i
                            ></a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-template>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <div class="d-flex flex-stack flex-wrap pt-10">
          <div class="d-flex align-items-center gap-6">
            <div class="flex align-items-center">
              <label
                for="pageSizeSelect"
                class="me-2 fs-6 fw-semibold text-gray-700"
                >Page Size:</label
              >
              <select
                id="pageSizeSelect"
                (change)="changePageSize($event)"
                class="cursor-pointer outline-none"
              >
                <option *ngFor="let size of pageSizes" [value]="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <div class="fs-6 fw-semibold text-gray-700">
              Showing {{ users.length }} of {{ totalUser }} users
            </div>
          </div>
          <ul class="pagination">
            <li
              class="page-item previous cursor-pointer"
              [class.disabled]="currentPage === 1"
            >
              <a class="page-link" (click)="changePage(currentPage - 1)">
                <i class="previous"></i>
              </a>
            </li>
            <li
              *ngFor="let page of [].constructor(totalPage); let i = index"
              class="page-item cursor-pointer"
              [class.active]="currentPage === i + 1"
            >
              <a class="page-link" (click)="changePage(i + 1)">{{ i + 1 }}</a>
            </li>
            <li
              class="page-item next cursor-pointer"
              [class.disabled]="currentPage === totalPage"
            >
              <a class="page-link" (click)="changePage(currentPage + 1)">
                <i class="next"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete User Modal -->
<div
  class="modal fade"
  [id]="'exampleModal-' + deleteModalId"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="exampleModalLabel">
          {{ "deleteUser" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body fs-4">
        {{ "deleteUserModal" | translate }}
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "cancel" | translate }}
        </button>
        <button
          (click)="deleteUser(deleteModalId)"
          type="button"
          class="btn btn-danger cursor-pointer"
          data-bs-dismiss="modal"
        >
          {{ "delete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-toast
  [message]="toastMessage"
  [type]="toastType"
  [showToast]="showToast"
></app-toast>
